import { useEffect } from 'react';
import { getCookie } from 'utils/bom-dom-manipulation/cookies';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import store from 'store';
import { setFirebaseToken } from 'store/actions';

export const InitializeFirebase = () => {
  useEffect(() => {
    try {
      if (SpringConfigs.WRAPPER_APP) {
        const token = getCookie('X_FCM_TOKEN');

        if (token && typeof token === 'string') {
          store.dispatch(setFirebaseToken(token));
        }
      } else {
        import(
          /* webpackChunkName: "get-firebase-token" */
          'utils/helpers/push-notification'
        ).then(async data => {
          const { initAndGetFirebaseToken } = data;
          const token = await initAndGetFirebaseToken();

          if (token) {
            store.dispatch(setFirebaseToken(token));
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  return null;
};
